import React from 'react'
import { FJSSummary } from './';
import { Link } from 'react-router-dom';

export const FJSList = ({ fjStories }) => {
  return (
    <>
      <div className=''>
        {/* fjStories && means it requires it to be loaded. If it doesn't exist, it doesn't display anything */}
        {fjStories && fjStories.map(fjStory => {
          return (
            <Link key={fjStory.id} to={`/fjStory/${fjStory.id}`}>
              <FJSSummary fjStory={fjStory} />
            </Link>
          )
        })}
      </div>
    </>
  )
}
